<!--
 * @Author: lijian
 * @Date:2022-11-24 14:49:04
 * @LastEditors: lijian
 * @LastEditTime: 2022-11-24 15:05:22
 * @Description:
-->
<template>
  <div class="page_nav">
    <h3 class="page_logo" @click="openHome">舆情产品</h3>
    <div class="nav_right">
      <ul class="nav_list">
        <li v-for="(item, index) in navList" :key="index" @click="openHome">
          <a :href="item.href">{{ item.name }}</a>
        </li>
      </ul>
      <button @click="openHome"><a href="#n6">免费试用</a></button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      navList: [
        {
          name: "核心特性",
          href: "#n1"
        },
        {
          name: "事件分析",
          href: "#n2"
        },
        {
          name: "服务优势",
          href: "#n3"
        },
        {
          name: "合作支持",
          href: "#n4"
        },
        {
          name: "新闻动态",
          href: "#n5"
        },
        {
          name: "联系我们",
          href: "#n7"
        }
      ]
    };
  },
  mounted() {},
  methods: {
    openHome() {
      this.$router.push({
        path: "/home"
      });
    }
  }
};
</script>

<style lang="less" scoped>
.page_nav {
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 100px;
  box-sizing: border-box;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  background: #3b43f2;
  > img {
    width: auto;
    height: 60%;
  }
  .page_logo {
    font-size: 26px;
    color: #fff;
  }
  .nav_right {
    display: flex;
    align-items: center;
    > button {
      width: 90px;
      height: 30px;
      background: #fff;
      border: none;
      border-radius: 80px;
      line-height: 30px;
      padding: 0;
      > a {
        width: 100%;
        height: 100%;
        font-size: 13px;
        text-decoration: none;
        color: #333;
      }
    }
    .nav_list {
      height: 100%;
      display: flex;
      align-items: center;
      margin-right: 20px;
      > li {
        height: 100%;
        > a {
          height: 100%;
          padding: 0 20px;
          color: #eee;
          font-size: 14px;
          text-decoration: none;
          &:hover {
            color: #fff;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/home/pageNav.vue